import { format } from 'date-fns'
import { useAuthStore } from '@/stores/auth'
import { useGet } from './useFetch'
import { ApiResponse, SupplierDailyAdPlayDetail } from '@magnetar/admin-api-interfaces'

interface UseSupplierDailyAdPlayDetailParams {
  supplierId: number
  startDate?: Date
  endDate?: Date
  granularity?: 'daily' | 'weekly' | 'monthly'
  clinicId?: number
  adId?: number
}

export const useSupplierDailyAdPlayDetail = ({
  supplierId,
  startDate,
  endDate,
  granularity = 'daily',
  clinicId,
  adId,
}: UseSupplierDailyAdPlayDetailParams) => {
  const { token } = useAuthStore()

  const queryParams = new URLSearchParams()
  if (startDate) {
    queryParams.append('startDate', format(startDate, 'yyyy-MM-dd'))
  }
  if (endDate) {
    queryParams.append('endDate', format(endDate, 'yyyy-MM-dd'))
  }
  queryParams.append('granularity', granularity)
  if (clinicId) {
    queryParams.append('clinicId', String(clinicId))
  }
  if (adId) {
    queryParams.append('adId', String(adId))
  }

  const url = `/api/ad-suppliers/${supplierId}/report/daily-detail?${queryParams.toString()}`

  const {
    data,
    error,
    isLoading,
    mutate,
  } = useGet<ApiResponse<SupplierDailyAdPlayDetail>>(
    token && supplierId ? url : null,
    undefined,
    token ?? '',
  )

  return {
    detailData: data?.data ?? { ads: [], rows: [] },
    isLoading,
    isError: error,
    mutate,
  }
}
